// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__DKP_c","bigColWidth":"Table_bigColWidth__ImmJd","biggerColWidth":"Table_biggerColWidth__3IVVb","row":"Table_row__3bgX2","col":"Table_col__1m6NX"};